//休息日+调休日=不拍高峰期的日期
export const nohighday = [
    "2025-12-27",
    "2025-12-28",
    "2026-01-01",
    "2026-01-02",
    "2026-01-03",
    "2026-01-04",
    "2026-01-10",
    "2026-01-11",
    "2026-01-17",
    "2026-01-18",
    "2026-01-24",
    "2026-01-25",
    "2026-01-31",
    "2026-02-01",
    "2026-02-07",
    "2026-02-08",
    "2026-02-14",
    "2026-02-15",
    "2026-02-16",
    "2026-02-17",
    "2026-02-18",
    "2026-02-19",
    "2026-02-20",
    "2026-02-21",
    "2026-02-22",
    "2026-02-23",
    "2026-02-28",
    "2026-03-01",
    "2026-03-07",
    "2026-03-08",
    "2026-03-14",
    "2026-03-15",
    "2026-03-21",
    "2026-03-22",
    "2026-03-28",
    "2026-03-29",
    "2026-04-04",
    "2026-04-05",
    "2026-04-06",
    "2026-04-11",
    "2026-04-12",
    "2026-04-18",
    "2026-04-19",
    "2026-04-25",
    "2026-04-26",
    "2026-05-01",
    "2026-05-02",
    "2026-05-03",
    "2026-05-04",
    "2026-05-05",
    "2026-05-09",
    "2026-05-10",
    "2026-05-16",
    "2026-05-17",
    "2026-05-23",
    "2026-05-24",
    "2026-05-30",
    "2026-05-31",
    "2026-06-06",
    "2026-06-07",
    "2026-06-13",
    "2026-06-14",
    "2026-06-19",
    "2026-06-20",
    "2026-06-21",
    "2026-06-27",
    "2026-06-28",
    "2026-07-04",
    "2026-07-05",
    "2026-07-11",
    "2026-07-12",
    "2026-07-18",
    "2026-07-19",
    "2026-07-25",
    "2026-07-26",
    "2026-08-01",
    "2026-08-02",
    "2026-08-08",
    "2026-08-09",
    "2026-08-15",
    "2026-08-16",
    "2026-08-22",
    "2026-08-23",
    "2026-08-29",
    "2026-08-30",
    "2026-09-05",
    "2026-09-06",
    "2026-09-12",
    "2026-09-13",
    "2026-09-19",
    "2026-09-20",
    "2026-09-25",
    "2026-09-26",
    "2026-09-27",
    "2026-10-01",
    "2026-10-02",
    "2026-10-03",
    "2026-10-04",
    "2026-10-05",
    "2026-10-06",
    "2026-10-07",
    "2026-10-10",
    "2026-10-11",
    "2026-10-17",
    "2026-10-18",
    "2026-10-24",
    "2026-10-25",
    "2026-10-31",
    "2026-11-01",
    "2026-11-07",
    "2026-11-08",
    "2026-11-14",
    "2026-11-15",
    "2026-11-21",
    "2026-11-22",
    "2026-11-28",
    "2026-11-29",
    "2026-12-05",
    "2026-12-06",
    "2026-12-12",
    "2026-12-13",
    "2026-12-19",
    "2026-12-20",
    "2026-12-25",
    "2026-12-26",
    "2026-12-27",
]